module.exports = __webpack_public_path__ + "img/ki.9de10c9.svg";